/**
 * @generated SignedSource<<9f7e51987681f4549de40290fc63bf21>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PaywallStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  UNSET = "UNSET",
}
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    name: string | null;
    key: string | null;
    type: string | null;
    alias: string | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content =
  {
    __typename?: "Content";
    id: string | null;
    type: string | null;
    title: string | null;
    status: string | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary =
  {
    __typename?: "FavouritedSummary";
    isFavourite: boolean | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser =
  {
    __typename?: "ContentMetadata_CurrentUserMetadataProvider_currentuser";
    favourited: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata =
  {
    __typename?: "ContentMetadata";
    currentuser: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_Anonymous =
  {
    __typename?: "Anonymous";
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_UnknownUser =
  {
    __typename?: "UnknownUser";
    accountId: string | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_User =
  {
    __typename?: "User";
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy =

    | WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_Anonymous
    | WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_KnownUser
    | WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_UnknownUser
    | WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy_User;
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History =
  {
    __typename?: "History";
    createdBy: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History_createdBy | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content =
  {
    __typename?: "Content";
    id: string | null;
    referenceId: string | null;
    title: string | null;
    hasRestrictions: boolean;
    hasViewRestrictions: boolean;
    hasInheritedRestrictions: boolean;
    type: string | null;
    status: string | null;
    operations: Array<WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult | null> | null;
    space: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space | null;
    ancestors: Array<WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content | null> | null;
    metadata: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_metadata_ContentMetadata;
    history: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content_history_History | null;
  };
export type WhiteboardUnifiedQuery_content_PaginatedContentListWithChild = {
  __typename?: "PaginatedContentListWithChild";
  nodes: Array<WhiteboardUnifiedQuery_content_PaginatedContentListWithChild_nodes_Content | null> | null;
};
export type WhiteboardUnifiedQuery_spaces_PaginatedSpaceList_nodes_Space_homepage_Content =
  {
    __typename?: "Content";
    id: string | null;
  };
export type WhiteboardUnifiedQuery_spaces_PaginatedSpaceList_nodes_Space = {
  __typename?: "Space";
  id: string | null;
  name: string | null;
  homepage: WhiteboardUnifiedQuery_spaces_PaginatedSpaceList_nodes_Space_homepage_Content | null;
};
export type WhiteboardUnifiedQuery_spaces_PaginatedSpaceList = {
  __typename?: "PaginatedSpaceList";
  nodes: Array<WhiteboardUnifiedQuery_spaces_PaginatedSpaceList_nodes_Space | null> | null;
};
export type WhiteboardUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser_space_Space =
  {
    __typename?: "Space";
    id: string | null;
  };
export type WhiteboardUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    space: WhiteboardUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser_space_Space | null;
  };
export type WhiteboardUnifiedQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: WhiteboardUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type WhiteboardUnifiedQuery_canvasToken_CanvasToken = {
  __typename?: "CanvasToken";
  token: string;
};
export type WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens_readOnlyToken_MediaToken =
  {
    __typename?: "MediaToken";
    value: string;
  };
export type WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens_readWriteToken_MediaToken =
  {
    __typename?: "MediaToken";
    value: string;
  };
export type WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens =
  {
    __typename?: "MediaAccessTokens";
    readOnlyToken: WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens_readOnlyToken_MediaToken | null;
    readWriteToken: WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens_readWriteToken_MediaToken | null;
  };
export type WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_configuration_MediaConfiguration =
  {
    __typename?: "MediaConfiguration";
    fileStoreUrl: string;
  };
export type WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession = {
  __typename?: "ContentMediaSession";
  accessTokens: WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_accessTokens_MediaAccessTokens;
  configuration: WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession_configuration_MediaConfiguration;
};
export type WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures_smartConnectors_SmartConnectorsFeature =
  {
    __typename?: "SmartConnectorsFeature";
    isEntitled: boolean;
  };
export type WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures_smartSections_SmartSectionsFeature =
  {
    __typename?: "SmartSectionsFeature";
    isEntitled: boolean;
  };
export type WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures =
  {
    __typename?: "WhiteboardFeatures";
    smartConnectors: WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures_smartConnectors_SmartConnectorsFeature | null;
    smartSections: WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures_smartSections_SmartSectionsFeature | null;
  };
export type WhiteboardUnifiedQuery_entitlements_Entitlements = {
  __typename?: "Entitlements";
  whiteboardFeatures: WhiteboardUnifiedQuery_entitlements_Entitlements_whiteboardFeatures_WhiteboardFeatures | null;
};
export type WhiteboardUnifiedQuery_dataSecurityPolicy_Confluence_dataSecurityPolicy_isActionEnabledForContent_DataSecurityPolicyDecision =
  {
    __typename?: "DataSecurityPolicyDecision";
    allowed: boolean | null;
  };
export type WhiteboardUnifiedQuery_dataSecurityPolicy_Confluence_dataSecurityPolicy =
  {
    __typename?: "Confluence_dataSecurityPolicy";
    isActionEnabledForContent: WhiteboardUnifiedQuery_dataSecurityPolicy_Confluence_dataSecurityPolicy_isActionEnabledForContent_DataSecurityPolicyDecision;
  };
export type WhiteboardUnifiedQuery_Query = {
  __typename?: "Query";
  paywallStatus: PaywallStatus | null;
  content: WhiteboardUnifiedQuery_content_PaginatedContentListWithChild | null;
  spaces: WhiteboardUnifiedQuery_spaces_PaginatedSpaceList | null;
  user: WhiteboardUnifiedQuery_user_AtlassianUser | null;
  canvasToken: WhiteboardUnifiedQuery_canvasToken_CanvasToken | null;
  contentMediaSession: WhiteboardUnifiedQuery_contentMediaSession_ContentMediaSession | null;
  entitlements: WhiteboardUnifiedQuery_entitlements_Entitlements;
  dataSecurityPolicy: WhiteboardUnifiedQuery_dataSecurityPolicy_Confluence_dataSecurityPolicy | null;
};
export type WhiteboardUnifiedQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  spaceKey?: InputMaybe<Scalars["String"]["input"]>;
  contentVersion: Scalars["Int"]["input"];
}>;
export type WhiteboardUnifiedQuery = WhiteboardUnifiedQuery_Query;
